export default "__VITE_ASSET__be028f9d__"